import CustomTable from "../../CustomTable";
import { pdficon4, plusicon } from "../../imagepath";
import React, { useState, useEffect, useContext } from "react";
import {
  Modal,
  Select,
  DatePicker,
  Button,
  message,
  Form,
  Skeleton,
  Popconfirm,
} from "antd";

import moment from "moment";
import { CSVLink } from "react-csv";
import {
  getComorbilidadesCode,
  getComorbilidadesTypeCode,
} from "../../../services/dim";
import { extractPatientIdFromUrl } from "../../../utils/helpers";
import { post } from "../../../services/base";
import { MedicInformationContext } from "../../../context/MedicInformationContextProvider";
import { actualizarComorbilidad } from "../../../services/api";
import {procedenciasCode} from "../../../utils/enums/statusCodes";
import {comorbilidadesEstatusCode} from "../../../utils/enums/statusCodes";

import { ExclamationCircleFilled } from "@ant-design/icons";

const { Option } = Select;
const CondicionesMedicasAdicionales = () => {
  const { afiliadoComorbilidades, updateCondiciones } = useContext(
    MedicInformationContext
  );

  const [modalVisible, setModalVisible] = useState(false);

  const [codeComorbilidades, setCodeComorbilidades] = useState([]);

  const [codeComorbilidadesType, setCodeComorbilidadesType] = useState([]);

  const [seletedComorbilidad, setSelectedComorbilidad] = useState({
    key: null,
    value: null,
  });

  const [seletedComorbilidadType, setSelectedComorbilidadType] = useState({
    key: null,
    value: null,
  });

  const [comorbilidadesForm] = Form.useForm();

  const [loading, setLoading] = useState(true);

  const [loadingAdd, setLoadingAdd] = useState(false);

  const gestor = localStorage.getItem("username");

  const afiliado = extractPatientIdFromUrl();

  useEffect(() => {
    const fetchData = async () => {
      try {

        const comorbilidadesTypeCode = await getComorbilidadesTypeCode();
        setCodeComorbilidadesType(comorbilidadesTypeCode);
        
        if (afiliadoComorbilidades.length >= 0) {
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [afiliadoComorbilidades]);

  const handleComorbilidadChange = (value, option) => {
    setSelectedComorbilidad({ key: option.key, value: value });
  };

  const handleComorbilidadTipoChange = async (value, option) => {
    setSelectedComorbilidadType({ key: option.key, value: value });

    const comorbilidadesCode = await getComorbilidadesCode(value);
    setCodeComorbilidades(comorbilidadesCode);

  };

  const handleSelectChange = async (record, value) => {
    try {
      const { confirm} = Modal;
      confirm({
        title: "Actualización tipo de condicion medica ",
        icon: <ExclamationCircleFilled />,
        centered: true,
        content:
          "¿Está seguro que desea actualizar el tipo de condicion?",
        okText: "Si",
        cancelText: "No",
        onOk() {
          return new Promise((resolve, reject) => {
            actualizarComorbilidad(record.id, {
              estatus: null,
              tipo: value,
            }).then(() => {
              message.success("Tipo de condicion medica actualizada.");
              updateCondiciones();
              resolve();
            });
          }).catch(() => console.log("Oops errors!"));
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } catch (error) {
      console.error(error);
    }
  };


  const [formData, setFormData] = useState({
    examen: "",
    fechaToma: null,
  });

  const handleModalCancel = () => {
    setModalVisible(false);
    comorbilidadesForm.resetFields();
  };

  const handleGuardarClick = async () => {
    comorbilidadesForm
      .validateFields()
      .then(async (values) => {
        if (
          values != undefined &&
          values.errorFields != undefined &&
          values.errorFields.length > 0
        ) {
          message.error("Los campos marcados son requeridos");
          return;
        }else{
          try {
            setLoadingAdd(true);
            const fechaSeleccionada = formData.fechaToma || moment().format('YYYY-MM-DD');
            const dataToSend = {
              afiliado: afiliado,
              descripcion: seletedComorbilidad.key,
              codigoTipo: seletedComorbilidadType.key,
              gestor: gestor,
              fecha: fechaSeleccionada,
            };
            var response = await post(
              "/DatosClinicos/comorbilidades",
              JSON.stringify(dataToSend)
            );
            if (response.data) message.success("Condicion Médica exitosamente.");
            setModalVisible(false);
            setLoadingAdd(false);
            updateCondiciones();
          } catch (error) {
            setLoadingAdd(false);
            console.error("Error creando rondicion médica:", error);
            message.error(
              "Error creando condicion médica Por favor, inténtelo de nuevo más tarde."
            );
          }
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  const handleActivarClick = async (comorbilidad) => {
    const estatus = comorbilidadesEstatusCode.Activa.value;
    await actualizarComorbilidad(comorbilidad.id, {estatus : estatus});
    message.success("Comorbilidad actualizada.");
    updateCondiciones();
  };

  const handleCancelarClick = async (comorbilidad) => {
    const estatus = comorbilidadesEstatusCode.Remision.value;
    await actualizarComorbilidad(comorbilidad.id, {estatus : estatus});
    message.success("Comorbilidad actualizada.");
    updateCondiciones();
  };

  const comorbilidadesCode =
    codeComorbilidades != undefined
      ? codeComorbilidades.map((option, index) => (
          <Option key={option.value} value={option.label}>
            {option.label}
          </Option>
        ))
      : [];
  const columns = [
    {
      title: "Condicion",
      dataIndex: "descripcion",
      key: "descripcion",
      sorter: (a, b) => a.descripcion.localeCompare(b.descripcion),
      searchable: true,
    },
    {
      title: "Fecha",
      dataIndex: "fecha",
      key: "fecha",
      sorter: (a, b) => a.fecha.localeCompare(b.fecha),
      searchable: true,
    },
    {
      title: "Estatus",
      dataIndex: "estado",
      key: "estado",
      sorter: (a, b) => a.estado.localeCompare(b.estado),
      render: (text, record) => (
        <Popconfirm
          title={`¿Estás seguro que deseas ${
            record.estado === "Remisión" ? "activar" : "inactivar"
          } esta condicion medica?`}
          onConfirm={() =>
            record.estado === "Remisión"
              ? handleActivarClick(record)
              : handleCancelarClick(record)
          }
          okText="Sí"
          cancelText="No"
        >
          <Button
            type="link"
            className="btn btn-primary"
            style={{
              backgroundColor:
                record.estado === "Remisión" ? "#ff9999" : "var(--mint-green)",
              borderColor:
                record.estado === "Remisión" ? "#ff9999" : "var(--mint-green)",
            }}
          >
            {record.estado === "Remisión" ? "Remision" : "Activa"}
          </Button>
        </Popconfirm>
      ),
    },
    {
      title: "Tipo",
      dataIndex: "tipo",
      key: "tipo",
      render: (text, record) => (
        <Select
          defaultValue = {record.tipo}
          style={{ width: 120 }}
          onChange={(value) => handleSelectChange(record, value)}
        >
          {codeComorbilidadesType.map((option) => (
            <Option key={option.key} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Gestor",
      dataIndex: "gestor",
      key: "gestor",
      sorter: (a, b) => a.gestor.localeCompare(b.gestor),
      searchable: true,
    },
    {
      title: "Fuente",
      dataIndex: "fuente",
      key: "fuente",
      sorter: (a, b) => a.fuente.localeCompare(b.fuente),
      searchable: true,
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {},
    getCheckboxProps: (record) => ({
      disabled: record.name === "",
    }),
  };
  return (
    <div className="card">
      <div className="card-header pb-0">
        <h4 className="card-title d-inline-block">
          Condiciones Médicas Adicionales
        </h4>{" "}
      </div>
      {loading ? (
        <div style={{ padding: "20px" }}>
          <Skeleton active />
        </div>
      ) : (
        <>
          {afiliadoComorbilidades && (
            <CustomTable
              dataSource={afiliadoComorbilidades}
              columns={columns}
              rowSelection={rowSelection}
              contexto={procedenciasCode.Comorbilidad.value}
              updateDataSource={updateCondiciones || []}
            />
          )}
          {afiliadoComorbilidades !== null && (
            <Button
              className="btn btn-primary add-pluss ms-2"
              onClick={() => setModalVisible(true)}
            >
              <img src={plusicon} alt="#" />
              Agregar
            </Button>
          )}
        </>
      )}
      <Modal
        title="Agregar Condiciones Médicas Adicionales"
        open={modalVisible}
        onCancel={handleModalCancel}
        footer={[
          <Button key="cancel" onClick={handleModalCancel}>
            Cancelar
          </Button>,
          <Button key="save" type="primary" loading={loadingAdd} onClick={handleGuardarClick}>
            Guardar
          </Button>,
        ]}
        centered
        style={{
          zIndex: 1042,
        }}
      >
        <Form form={comorbilidadesForm}>
        <div>
            <label htmlFor="tipoExam">Tipo</label>
            <Form.Item
              name={"tipoExam"}
              rules={[{ required: true, message: "Es requerido" }]}
            >
              <Select
                id="tipoExam"
                onChange={(value, option) =>
                  handleComorbilidadTipoChange(value, option)
                }
                style={{ width: "100%" }}
              >
                {codeComorbilidadesType &&
                  codeComorbilidadesType.length > 0 &&
                  codeComorbilidadesType.map((tipo) => (
                    <Option key={tipo.value} value={tipo.value}>
                      {tipo.label}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label htmlFor="condicion">Condición</label>
            <Form.Item
              name={"condicion"}
              rules={[{ required: true, message: "Es requerido" }]}
            >
              <Select
                id="condicion"
                style={{ width: "100%" }}
                value={seletedComorbilidad.value}
                onChange={handleComorbilidadChange}
                showSearch
                
              >
                {comorbilidadesCode}
              </Select>
            </Form.Item>
          </div>
          <div>
            <label htmlFor="datePicker">Fecha de Toma</label>
            <Form.Item
              name={"fecha"}
              rules={[{ required: true, message: "Es requerida" }]}
            >
            <DatePicker
              id="datePicker"
              style={{ width: "100%" }}
              placeholder="Seleccionar fecha"
              value={formData.fechaToma}
              onChange={(date) => setFormData({ ...formData, fechaToma: date })}
            />
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default CondicionesMedicasAdicionales;
